(function () {
  'use strict';

  var activeRequest = null;

  function drawer() {
    return document.getElementById('Cart-Drawer');
  }

  function ensureDrawerApi(element) {
    if (!element) return null;

    // The drawer is rendered after the product content. On a heavily enhanced
    // product page the native custom element may finish upgrading a moment
    // later than the add-to-cart flow, so keep the live-theme behaviour
    // available immediately instead of redirecting the customer to /cart.
    if (typeof element.show !== 'function') {
      element.show = function (opener) {
        this.openedBy = opener || null;
        this.setAttribute('open', '');
        if (this.openedBy) this.openedBy.setAttribute('aria-expanded', 'true');
        if (window.webvista && typeof window.webvista.trapFocus === 'function') {
          window.webvista.trapFocus(this);
        }
        if (window.webvista && typeof window.webvista.disablePageScroll === 'function') {
          window.webvista.disablePageScroll();
        } else {
          document.documentElement.style.overflow = 'hidden';
        }
      };
    }

    if (typeof element.hide !== 'function') {
      element.hide = function () {
        this.removeAttribute('open');
        if (this.openedBy) {
          this.openedBy.setAttribute('aria-expanded', 'false');
          if (window.webvista && typeof window.webvista.removeTrapFocus === 'function') {
            window.webvista.removeTrapFocus(this.openedBy);
          }
        }
        if (window.webvista && typeof window.webvista.enablePageScroll === 'function') {
          window.webvista.enablePageScroll();
        } else {
          document.documentElement.style.overflow = '';
        }
        this.openedBy = null;
      };
    }

    return element;
  }

  function updateVisibleCounts(count) {
    document.querySelectorAll('[data-mg-cart-count], .mg-rex-cart-link b').forEach(function (node) {
      node.textContent = String(count);
    });
  }

  function readCart() {
    return window.fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Impossibile leggere il carrello');
      return response.json();
    }).then(function (cart) {
      updateVisibleCounts(Number(cart.item_count || 0));
      return cart;
    });
  }

  function sectionUrl(sectionId) {
    var url = new URL(window.location.href);
    url.hash = '';
    url.searchParams.set('section_id', sectionId);
    return url.toString();
  }

  function refreshDrawer() {
    var element = drawer();
    if (!element) return Promise.reject(new Error('Drawer non disponibile'));
    if (activeRequest) return activeRequest;

    var sectionId = element.dataset.section;
    if (!sectionId) return readCart();

    activeRequest = window.fetch(sectionUrl(sectionId), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Impossibile aggiornare il drawer');
      return response.text();
    }).then(function (html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var incoming = parsed.querySelector('#Cart-Drawer-Details');
      var current = element.querySelector('#Cart-Drawer-Details');
      if (incoming && current) current.replaceWith(incoming);
      return readCart();
    }).finally(function () {
      activeRequest = null;
    });

    return activeRequest;
  }

  function showDrawer(opener) {
    var element = ensureDrawerApi(drawer());
    if (!element) return Promise.resolve(false);

    return refreshDrawer().catch(function () {
      return readCart().catch(function () {});
    }).then(function () {
      element.show(opener || document.activeElement || null);
      return true;
    });
  }

  ensureDrawerApi(drawer());
  document.addEventListener('DOMContentLoaded', function () {
    ensureDrawerApi(drawer());
  }, { once: true });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-mg-cart-opener], .mg-rex-cart-link, a.mg-header-icon[href*="/cart"]');
    if (!link || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (document.body.classList.contains('template-cart')) return;
    event.preventDefault();
    showDrawer(link);
  });

  document.addEventListener('mg:cart:open', function (event) {
    showDrawer(event.detail && event.detail.opener);
  });

  window.MGLiveCart = {
    open: showDrawer,
    refresh: refreshDrawer,
    read: readCart
  };
})();


/* Minimal Gamers — fluidita' (Antonio 04/10/2026). Le animazioni infinite si fermano quando sono fuori dallo
   schermo; sui telefoni si fermano anche quelle che obbligano il browser a ridisegnare a ogni fotogramma
   (bordi «orbit» che girano, bagliori, linee di scansione): restano visibili ma ferme. Regole in mg-ui-polish.css. */
(function () {
  'use strict';
  if (window.__mgFluido || !document.getAnimations || !('IntersectionObserver' in window)) return;
  window.__mgFluido = true;
  var LEGGERE = { transform: 1, opacity: 1, translate: 1, rotate: 1, scale: 1 };
  var TECNICHE = { offset: 1, easing: 1, composite: 1, computedOffset: 1 };
  var seguiti = new WeakSet();
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { e.target.classList.toggle('mg-anim-fuori', !e.isIntersecting); });
  }, { rootMargin: '200px 0px' });

  function pesante(a) {
    try {
      var props = [];
      a.effect.getKeyframes().forEach(function (k) {
        Object.keys(k).forEach(function (p) { if (!TECNICHE[p] && props.indexOf(p) < 0) props.push(p); });
      });
      if (!props.length) return true;
      return props.some(function (p) { return !LEGGERE[p]; });
    } catch (e) { return true; }
  }

  function controlla() {
    document.getAnimations().forEach(function (a) {
      if (typeof CSSAnimation !== 'undefined' && !(a instanceof CSSAnimation)) return;
      var eff = a.effect, t = eff && eff.target, giri;
      if (!t || t.nodeType !== 1) return;
      try { giri = eff.getTiming().iterations; } catch (e) { return; }
      if (giri !== Infinity) return;
      if (pesante(a) && !t.classList.contains('mg-anim-pesante')) t.classList.add('mg-anim-pesante');
      if (!seguiti.has(t)) { seguiti.add(t); io.observe(t); }
    });
  }

  var attesa = 0;
  function pianifica() {
    if (attesa) return;
    attesa = window.setTimeout(function () { attesa = 0; controlla(); }, 400);
  }
  function avvia() {
    controlla();
    new MutationObserver(pianifica).observe(document.body, { childList: true, subtree: true });
    window.setTimeout(controlla, 2500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia, { once: true });
  else avvia();
  window.addEventListener('load', function () { window.setTimeout(controlla, 300); }, { once: true });
})();
